import { render, staticRenderFns } from "./AgentTransactionList.vue?vue&type=template&id=3b3d61c0&scoped=true"
import script from "./AgentTransactionList.vue?vue&type=script&lang=js"
export * from "./AgentTransactionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3d61c0",
  null
  
)

export default component.exports